import React from 'react';
import { get } from 'helpers/utilities';
import { withRouter, Redirect } from 'react-router-dom';
import NotFound from '../NotFound';
import ServerError from '../ServerError';
import ClientError from '../ClientError';

class ErrorHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentWillUpdate(props) {
    const { error } = this.state;
    if (error && get(props, 'location.pathname') !== get(this.props, 'location.pathname')) {
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({ error: null });
    }
  }

  componentDidCatch(error) {
    this.setState({ error });
  }

  renderError(error) {
    const redirectTo = window.localStorage.getItem('redirect-to');
    if (redirectTo) {
      window.localStorage.removeItem('redirect-to');
      return <Redirect to={redirectTo} />;
    }
    if (error.message === 'No Entry') {
      return <NotFound />;
    }
    if (error.message !== 'Internal Server Error') {
      return <ClientError error={error.stack} />;
    }
    return <ServerError error={error.stack} />;
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    return error ? this.renderError(error) : children;
  }
}

export default withRouter(ErrorHandler);
